import Api from './api'
import { getXUserKey, getXAPIEnv } from '@/plugins/account'

export default class GiftAPI {

  static async request(params) {
    return await Api(
      'gift',
      params.endpoint,
      params.method || 'get',
      params.data || {},
      params.headers || { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() },
      params.loading !== undefined ? params.loading : true
    )
  }

  static async create(coupon) {
    return await GiftAPI.request({
      endpoint: 'gifts',
      method: 'post',
      data: coupon,
      loading: false
    });
  }

  static async get(code) {
    return await GiftAPI.request({
      endpoint: `gifts/${code}`,
      loading: false
    });
  }

  static async list(expired = null, divulgation = null, page = null, limit = null, sort = null, direction = null) {
    const query = { expired, divulgation, page, limit, sort, direction }
    return await GiftAPI.request({
      endpoint: 'gifts',
      data: query,
      loading: false
    });
  }

  static async pause(couponCode) {
    return await GiftAPI.request({
      endpoint: `gifts/pause/${couponCode}`,
      method: 'put',
      loading: false
    });
  }

  static async reactivate(couponCode, couponExpiration) {
    return await GiftAPI.request({
      endpoint: `gifts/reactivate/${couponCode}`,
      method: 'put',
      data: {
        expiration: couponExpiration
      },
      loading: false
    });
  }

  static async delete(code) {
    return await GiftAPI.request({
      endpoint: `gifts/${code}`,
      method: 'delete',
      loading: false
    });
  }
}
